import React from 'react';
import { useEditor } from '@craftjs/core';
import { Paper, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  settings: {
    padding: theme.spacing(2),
    height: '100%',
    overflow: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  noSelection: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    marginTop: theme.spacing(4),
  },
}));

export const SettingsPanel = () => {
  const classes = useStyles();
  const { selected, actions } = useEditor((state, query) => {
    const currentNodeId = query.getEvent('selected').last();
    let selected;

    if (currentNodeId) {
      selected = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings:
          state.nodes[currentNodeId].related &&
          state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };
    }

    return {
      selected,
    };
  });

  return (
    <Paper className={classes.settings}>
      <Typography variant="h6" className={classes.title}>
        Propiedades
      </Typography>

      {selected ? (
        <Box>
          <Typography variant="subtitle1" gutterBottom>
            {selected.name}
          </Typography>
          {selected.settings && React.createElement(selected.settings)}
          {selected.isDeletable && (
            <Box mt={2}>
              <MuiButton
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={() => {
                  actions.delete(selected.id);
                }}
              >
                Eliminar componente
              </MuiButton>
            </Box>
          )}
        </Box>
      ) : (
        <Typography className={classes.noSelection}>
          Selecciona un componente para ver sus propiedades
        </Typography>
      )}
    </Paper>
  );
};

// Import necesario que faltaba
import { Button as MuiButton } from '@material-ui/core';